// extracted by css-extract-rspack-plugin
export default {"list":"iPTUMFJWDeE_TlzP","conditionText":"EDN7RfrVG38QHyIC"};